module.exports = __webpack_public_path__ + "img/1.06.0a4d05fc.jpg";